// Create types
export const USER_CREATE_ERROR = 'USER_CREATE_ERROR';
export const USER_CREATE_LOADING = 'USER_CREATE_LOADING';
export const USER_CREATE_SUCCESS = 'USER_CREATE_SUCCESS';
export const USER_CREATE_VIOLATIONS = 'USER_CREATE_VIOLATIONS';
export const USER_CREATE_RESET = 'USER_CREATE_RESET';

// Show types
export const USER_SHOW_ERROR = 'USER_SHOW_ERROR';
export const USER_SHOW_LOADING = 'USER_SHOW_LOADING';
export const USER_SHOW_RETRIEVED_SUCCESS = 'USER_SHOW_RETRIEVED_SUCCESS';
export const USER_SHOW_RESET = 'USER_SHOW_RESET';

// Update types
export const USER_UPDATE_RESET = 'USER_UPDATE_RESET';
export const USER_UPDATE_UPDATE_ERROR = 'USER_UPDATE_UPDATE_ERROR';
export const USER_UPDATE_UPDATE_LOADING = 'USER_UPDATE_UPDATE_LOADING';
export const USER_UPDATE_UPDATE_SUCCESS = 'USER_UPDATE_UPDATE_SUCCESS';
export const USER_UPDATE_RETRIEVE_ERROR = 'USER_UPDATE_RETRIEVE_ERROR';
export const USER_UPDATE_RETRIEVE_LOADING = 'USER_UPDATE_RETRIEVE_LOADING';
export const USER_UPDATE_RETRIEVE_SUCCESS = 'USER_UPDATE_RETRIEVE_SUCCESS';
export const USER_UPDATE_UPDATE_VIOLATIONS = 'USER_UPDATE_UPDATE_VIOLATIONS';

// Delete types
export const USER_DELETE_ERROR = 'USER_DELETE_ERROR';
export const USER_DELETE_LOADING = 'USER_DELETE_LOADING';
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS';
export const USER_DELETE_RESET = 'USER_DELETE_RESET';

// List types
export const USER_LIST_ERROR = 'USER_LIST_ERROR';
export const USER_LIST_LOADING = 'USER_LIST_LOADING';
export const USER_LIST_RESET = 'USER_LIST_RESET';
export const USER_LIST_PAGINATION = 'USER_LIST_PAGINATION';
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS';
export const USER_LIST_ORDER = 'USER_LIST_ORDER';
export const USER_LIST_PAGE = 'USER_LIST_PAGE';

// Delete types
export const USER_RESET_PASSWORD_ERROR = 'USER_RESET_PASSWORD_ERROR';
export const USER_RESET_PASSWORD_LOADING = 'USER_RESET_PASSWORD_LOADING';
export const USER_RESET_PASSWORD_SUCCESS = 'USER_RESET_PASSWORD_SUCCESS';
export const USER_RESET_PASSWORD_RESET = 'USER_RESET_PASSWORD_RESET';


// WEBPACK FOOTER //
// ./src/store/modules/user/mutation-types.js